import ContentWrap from "tr-grid-content-wrap/es6/ContentWrap";
import RowGrouping from "tr-grid-row-grouping/es6/RowGrouping";
import RowSelection from "tr-grid-row-selection/es6/RowSelection";
import TitleWrap from "tr-grid-titlewrap/es6/TitleWrap";

export default {
  renderInstrumentsGrid() {
    let dataToggle = document.getElementById("change-data-toggle");
    let tabLabel = "Reference";
    if(!dataToggle.checked){
      tabLabel = "corporate actions";
    }
    const rowSelection = new RowSelection();
    const config = {
      sorting: {
        threeStatesSorting: true,
      },
      columns: this.equityColumns,
      dataModel: {
        fields: this.equityColumns.map((column) => column.field),
        data: this.generateInstrumentItems(),
      },
      rowSelection: {
        basedOnContent: true,
        selectionChanged: (event) => {
          const selectedRow = event.api.getRowData(event.selectedRows);
          console.log(selectedRow);
          this.selectedQuotePermId = selectedRow["int_quote_perm_id"];
          this.selectedIssuePermId = selectedRow["int_issue_perm_id"];
          this.selectedRIC = selectedRow["int_ric"];
          this.selectedGlobalRIC = selectedRow["int_ric"];
          this.rowClickFlag = [0, 0, 0, 0, 0];
          this.selectedInstrumentName = selectedRow["int_security_description"];
          this.$refs.instrumentDialog.opened = true;
          this.switchTab({
            target: {
              label: tabLabel,
            },
          });
          // Create random sample data
          // this.sampleEquityReferenceChanges = this.generateEquityReferenceChangesItems()
          this.sampleEquityCorporateActionsReferenceChanges =
            this.generateEquityCorporateActionsReferenceChangesItems(
              this.getRandomInt(3, 5)
            );
        },
      },
      extensions: [
        new RowGrouping(),
        rowSelection,
        new ContentWrap(),
        new TitleWrap(),
      ]
    };
    let grid = this.$refs.instrumentsGrid;
    if (grid) {
      grid.addEventListener("configured", function(e) {
        let core = e.detail.api.getCoreGrid();
        var plugin = core.getPlugin("TitleWrap");
        plugin.adjustRowHeight(core);
      });
      grid.config = config;
    }
  },
  renderReferenceChangesGrid() {

    function dateSorting(rowDefA, rowDefB, order) {
      let rowA = new Date(rowDefA.getRowData());
      let rowB = new Date(rowDefB.getRowData());
      let timeA = rowA.getTime();
      let timeB = rowB.getTime();

      return (timeA - timeB) * order;
    }
    const config = {
      sorting: {
        sortableColumns: true,
        multiColumn: true,
        initialSort: [{
            colIndex: 0,
            sortLogic: dateSorting
        }]
      },
      columns: this.equityReferenceChangeColumns,
      dataModel: {
        fields: this.equityReferenceChangeColumns.map((column) => column.field),
        data: this.generateEquityReferenceChangesItems(),
      },
      extensions: [new ContentWrap(), new TitleWrap()],
    };
    setTimeout(() => {
      if (this.$refs.referenceChangesGrid) {
        this.$refs.referenceChangesGrid.config = config;
      }
    }, 500);
    if (this.$refs.referenceChangesGrid) {
      this.$refs.referenceChangesGrid.config = config;
    }
    this.refFieldsFlag = true;
  },
  renderCachedReferenceGrid() {
    const config = {
      sorting: {
        sortableColumns: true,
        multiColumn: true,
        initialSort: [{
            colIndex: 0,
            sortOrder: "a"
        }, {
            colIndex: 1,
            sortOrder: "a"
        }, {
            colIndex: 2,
            sortOrder: "a"
        }]
      },
      columns: this.equityReferenceChangeColumns,
      dataModel: {
        fields: this.equityReferenceChangeColumns.map((column) => column.field),
        data: this.equityReferenceChangesItems,
      },
      extensions: [new ContentWrap(), new TitleWrap()],
    };
    setTimeout(() => {
      if (this.$refs.referenceChangesGrid) {
        this.$refs.referenceChangesGrid.config = config;
      }
    }, 500);
    this.refFieldsFlag = true;
  },
  renderPricingGrid() {
    const config = {
      sorting: {
        threeStatesSorting: true,
      },
      columns: this.equityPricingColumns,
      dataModel: {
        fields: this.equityPricingColumns.map((column) => column.field),
        data: this.generateEquityPricingItems(),
      },
      extensions: [new ContentWrap(), new TitleWrap()],
    };
    if (this.$refs.pricingGrid) {
      this.$refs.pricingGrid.config = config;
    }
    this.renderPricingChart();
  },
  renderPricingChart() {
    const price_data = this.pricingData;
    let chartFlag = 0;
    if (
      Number(price_data[0]["prc_open_price"]) < 0 ||
      Number(price_data[0]["prc_high_price"]) < 0 ||
      Number(price_data[0]["prc_low_price"]) < 0 ||
      Number(price_data[0]["prc_universal_close_price"]) < 0
    ) {
      chartFlag = 1;
    }
    if (
      (Number(price_data[0]["prc_ask_price"]) < 0 ||
        Number(price_data[0]["prc_bid_price"]) < 0 ||
        Number(price_data[0]["prc_mid_price"]) < 0) &&
      chartFlag == 1
    ) {
      chartFlag = 2;
    }
    function formatDate(date) {
      let d =
        date.slice(0, 4) + "-" + date.slice(4, 6) + "-" + date.slice(6, 8);
      return d;
    }
    function uniq(d) {
        return d.sort(function compare(a, b) {
          var dateA = new Date(a.time);
          var dateB = new Date(b.time);
          return dateA - dateB;
        }).filter(function(item, pos, ary) {
            return !pos || item["time"] != ary[pos - 1]["time"];
        });
      }

    if (chartFlag == 0) {
      let data = [];
      let data2 = [];
      for (let i = 0; i < price_data.length; i++) {
        data.push({
          time: formatDate(price_data[i]["prc_trade_date"]),
          open: Number(price_data[i]["prc_open_price"]),
          high: Number(price_data[i]["prc_high_price"]),
          low: Number(price_data[i]["prc_low_price"]),
          close: Number(price_data[i]["prc_universal_close_price"]),
        });
        data2.push({
          time: formatDate(price_data[i]["prc_trade_date"]),
          value: Number(price_data[i]["prc_volume"]),
        });
      }
      data = uniq(data);
      data2 = uniq(data2);
      console.log(data);
      const chart = document.getElementById("pricing_chart");
      chart.config = {
        series: [
          {
            type: "bar",
            data: data,
          },
          {
            type: "volume",
            seriesOptions: {
              priceScaleId: "",
              priceFormat: {
                type: "volume",
              },
              lineWidth: 3,
            },
            data: data2,
          },
        ],
      };
      setTimeout(() => {
        chart.chart.priceScale("").applyOptions({
          scaleMargins: {
            top: 0.9,
            bottom: 0,
          },
        });
      }, 800);
    } else if (chartFlag == 1) {
      let data = [];
      let data2 = [];
      for (let i = 0; i < price_data.length; i++) {
        data.push({
          time: formatDate(price_data[i]["prc_trade_date"]),
          value: Number(price_data[i]["prc_ask_price"]),
        });
        data2.push({
          time: formatDate(price_data[i]["prc_trade_date"]),
          value: Number(price_data[i]["prc_bid_price"]),
        });
      }
      data = uniq(data);
      data2 = uniq(data2);
      const chart = document.getElementById("pricing_chart");
      chart.config = {
        series: [
          {
            type: "line",
            data: data,
          },
          {
            type: "line",
            data: data2,
          },
        ],
      };
    } else {
      this.priceChartFlag = false;
    }
    this.loading = false;
  },
  renderCorporateActionsReferenceEventsGrid() {
    const rowSelection = new RowSelection();
    const config = {
      sorting: {
        threeStatesSorting: true,
      },
      columns: this.equityCorporateActionsReferenceEventColumns,
      dataModel: {
        fields: this.equityCorporateActionsReferenceEventColumns.map(
          (column) => column.field
        ),
        data: this.equityCorporateActionsReferenceEventFields,
      },
      rowSelection: {
        basedOnContent: true,
        selectionChanged: (event) => {
          const selectedRow = event.api.getRowData(event.selectedRows);
          delete selectedRow["SELECTED_ROW"];
          console.log(selectedRow["xri_event_id"]);
          this.equityCorporateActionsReferenceFields = [selectedRow];
          const filteredChangesResult =
            this.equityCorporateActionsReferenceFieldChangesQueryResult.filter(
              (item) => item["xrd_event_id"] === selectedRow["xri_event_id"]
            )[0];
          this.equityCorporateActionsReferenceFieldChanges =
            this.returnParsedCorporateActionsReferenceFieldChanges(
              filteredChangesResult
            );

          this.renderCorporateActionsReferenceChangesGrid();
        },
      },
      extensions: [new ContentWrap(), rowSelection],
      whenDefined: () => {
        rowSelection.selectSingleRow(0);
      },
    };

    if (this.$refs.equityCorporateActionsReferenceEventsGrid) {
      this.$refs.equityCorporateActionsReferenceEventsGrid.config = config;

      setTimeout(() => {
        const selectedRow =
          this.$refs.equityCorporateActionsReferenceEventsGrid.api.getRowData(
            0
          );
        if (selectedRow) {
          delete selectedRow["SELECTED_ROW"];
          this.equityCorporateActionsReferenceFields = [selectedRow];

          const filteredChangesResult =
            this.equityCorporateActionsReferenceFieldChangesQueryResult.filter(
              (item) => item["xrd_event_id"] === selectedRow["xri_event_id"]
            )[0];

          this.equityCorporateActionsReferenceFieldChanges =
            this.returnParsedCorporateActionsReferenceFieldChanges(
              filteredChangesResult
            );

          this.renderCorporateActionsReferenceChangesGrid();
        }
      }, 500);
    }
  },
  renderCorporateActionsReferenceChangesGrid() {
    const config = {
      sorting: {
        threeStatesSorting: true,
      },
      headerRowHeight: 48,
      columns: this.equityReferenceChangeColumns,
      dataModel: {
        fields: this.equityReferenceChangeColumns.map((column) => column.field),
        data: this.equityCorporateActionsReferenceFieldChanges,
      },
      extensions: [new ContentWrap(), new TitleWrap()],
    };
    if (this.$refs.corporateActionsReferenceChangesGrid) {
      this.$refs.corporateActionsReferenceChangesGrid.config = config;
    }
  },
  renderCorporateActionsEventsGrid() {
    const rowSelection = new RowSelection();
    const config = {
      sorting: {
      threeStatesSorting: true,
      },
      headerRowHeight: 48,       // fallback (if library uses this naming)
      columns: this.equityCorporateActionsEventColumns,
      dataModel: {
      fields: this.equityCorporateActionsEventColumns.map(
        (column) => column.field
      ),
      data: this.equityCorporateActionsEventItems,
      },
      rowSelection: {
      basedOnContent: true,
      selectionChanged: (event) => {
        const selectedRow = event.api.getRowData(event.selectedRows);
        console.log(selectedRow);
        this.sampleEquityCorporateActionsEventChanges =
        this.generateEquityCorporateActionsEventChangesItems(
          this.getRandomInt(5, 10)
        );
        this.renderCorporateActionsEventChangesGrid();
      },
      },
      extensions: [new ContentWrap(), new TitleWrap(), rowSelection],
      whenDefined: () => {
      rowSelection.selectSingleRow(0);
      this.renderCorporateActionsEventChangesGrid();
      },
    };
    if (this.$refs.corporateActionsEventsGrid) {
      this.$refs.corporateActionsEventsGrid.config = config;
    }
  },
  renderCorporateActionsEventChangesGrid() {
    const config = {
      sorting: {
        threeStatesSorting: true,
      },
      columns: this.equityReferenceChangeColumns,
      dataModel: {
        fields: this.equityReferenceChangeColumns.map((column) => column.field),
        data: this.sampleEquityCorporateActionsEventChanges,
      },
      extensions: [new ContentWrap(), new TitleWrap()],
    };
    if (this.$refs.corporateActionsEventChangesGrid) {
      this.$refs.corporateActionsEventChangesGrid.config = config;
    }
  },

  returnParsedCorporateActionsReferenceFieldChanges(
    corporateActionsReferenceFieldChanges
  ) {

    const table_prefix="xrd_";

    if(!corporateActionsReferenceFieldChanges) {
      corporateActionsReferenceFieldChanges = {
        [`${table_prefix}dsp_st_publish_date`]: '', 
        [`${table_prefix}action`]: ''
      };
    }

    const actionMap = {
      I: "Insert",
      U: "Update",
      D: "Delete",
    };
    const rawAction = (corporateActionsReferenceFieldChanges[`${table_prefix}action`] || "").trim();

    let itemTemplate = {
      publishedDate:
      corporateActionsReferenceFieldChanges[`${table_prefix}dsp_st_publish_date`],
      publishSegment:
      corporateActionsReferenceFieldChanges[`${table_prefix}dsp_st_publish_segment`],
      action: actionMap[rawAction] || rawAction || "",
      field: "",
      previous: "",
      current: "",
    };

    let fieldNamesArray = Object.keys(corporateActionsReferenceFieldChanges)
      .filter((key) => key.endsWith("_change_flag"))
      .filter((key) => corporateActionsReferenceFieldChanges[key] === "Y")
      .map((key) => key.replace("_change_flag", "").substring(4));

    let fieldChanges = fieldNamesArray.map((fieldName) => {
      let item = JSON.parse(JSON.stringify(itemTemplate));
      item.field = fieldName;
      item.previous =
        corporateActionsReferenceFieldChanges[`${table_prefix}${fieldName}_previous`];
      item.current =
        corporateActionsReferenceFieldChanges[`${table_prefix}${fieldName}`];
      return item;
    });

    let dataParsed = fieldChanges.map((fieldChange) => {
      return {
        ...itemTemplate,
        field: fieldChange.field,
        previous: fieldChange.previous,
        current: fieldChange.current,
      };
    });

    dataParsed.forEach((data) => {
      this.equityCorporateActionsReferenceFields[0][`xri_${data.field}`] = data.current || this.equityCorporateActionsReferenceFields[0][`xri_${data.field}`];
    });

    this.highlightEquityCorporateActionsReferenceFieldChanges = dataParsed
      .filter((fieldChange) => corporateActionsReferenceFieldChanges[`${table_prefix}${fieldChange.field}_change_flag`] === "Y")
      .map((fieldChange) => fieldChange.field);
    return dataParsed;
  },
};
